import { Box, Text, Wrap } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { isBrowser } from "react-device-detect";

const Footer = () => {
  return (
    <>
      <Box
        position="sticky"
        bottom="0"
        left={{ base: 0 }}
        right="0"
        minHeight={"2.5rem"}
        bg={"bg.muted"}
        borderTop="1px solid"
        borderTopColor={"bg.emphasized"}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        color={"fg.muted"}
        style={{ zIndex: 999 }}
      >
        {!isBrowser && (
          <div>
            <Text>
              © {new Date().getFullYear()} Light Group VIP. All rights
              reserved.
            </Text>
          </div>
        )}
        {isBrowser && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
              flex: 1,
            }}
          >
            <Wrap style={{ textAlign: "center", justifyContent: "center" }}>
              <Text>© {new Date().getFullYear()} Light Group VIP.</Text>
              <Text> All rights reserved.</Text>
            </Wrap>
            <span> | </span>
            <Link to="/privacy-policy" style={{ textAlign: "center" }}>
              Privacy Policy
            </Link>
            <span> | </span>
            <Link to="/terms-of-use" style={{ textAlign: "center" }}>
              Terms of Use
            </Link>
          </div>
        )}
      </Box>
    </>
  );
};

export default Footer;
